// extracted by mini-css-extract-plugin
export default {"foodDrug":"style-module--food-drug--51ddd","wrap":"style-module--wrap--24660","title":"style-module--title--25757"};